import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ChatIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M27.2 2H4.8C3.26 2 2.014 3.26 2.014 4.8L2 30L7.6 24.4H27.2C28.74 24.4 30 23.14 30 21.6V4.8C30 3.26 28.74 2 27.2 2ZM9 11.8H23C23.77 11.8 24.4 12.43 24.4 13.2C24.4 13.97 23.77 14.6 23 14.6H9C8.23 14.6 7.6 13.97 7.6 13.2C7.6 12.43 8.23 11.8 9 11.8ZM17.4 18.8H9C8.23 18.8 7.6 18.17 7.6 17.4C7.6 16.63 8.23 16 9 16H17.4C18.17 16 18.8 16.63 18.8 17.4C18.8 18.17 18.17 18.8 17.4 18.8ZM23 10.4H9C8.23 10.4 7.6 9.77 7.6 9C7.6 8.23 8.23 7.6 9 7.6H23C23.77 7.6 24.4 8.23 24.4 9C24.4 9.77 23.77 10.4 23 10.4Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
